module.exports = __webpack_public_path__ + "static/media/8.c1cc4636.jpg";